var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPendingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7501 4.52249V4.53749V6.03749C16.0426 6.44249 18.3751 9.43499 17.9701 12.7275C17.6251 15.4575 15.4801 17.625 12.7501 17.9475V19.4475C16.8751 19.035 19.8751 15.375 19.4626 11.25C19.1251 7.68749 16.2976 4.87499 12.7501 4.52249ZM11.2501 4.54499C9.7876 4.68749 8.3926 5.24999 7.2526 6.19499L8.3251 7.30499C9.1651 6.62999 10.1776 6.19499 11.2501 6.04499V4.54499ZM6.1951 7.25249C5.2501 8.39249 4.6876 9.77999 4.5376 11.25H6.0376C6.1801 10.185 6.6001 9.17249 7.2676 8.32499L6.1951 7.25249ZM14.6251 9.37499L10.9651 13.035L9.3751 11.445L8.5801 12.24L10.9651 14.625L15.4201 10.17L14.6251 9.37499ZM4.5451 12.75C4.6951 14.22 5.2726 15.6075 6.2026 16.7475L7.2676 15.675C6.6076 14.8275 6.1801 13.815 6.0451 12.75H4.5451ZM8.3251 16.7775L7.2526 17.805C8.3851 18.75 9.7801 19.3425 11.2501 19.5V18C10.1851 17.865 9.1726 17.4375 8.3251 16.7775Z",
    fill: "#E98C00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingIcon);
export default __webpack_public_path__ + "static/media/PendingIcon.22b8a5c5426374c702312e3031dbbb51.svg";
export { ForwardRef as ReactComponent };